//* Copie e cole este template para criar uma nova fase
<template>
  <div v-if="!!phaseData">
    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" :key="'notes' + phaseKey" />
    </field-label>
  </div>
</template>
<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import TextArea from '@/components/TextArea.vue'
import FieldLabel from '@/components/FieldLabel.vue'

export default {
  components: { TextArea, FieldLabel },
  extends: BasePhase,
  data() {
    return {}
  },
  methods: {
    getDefaultData() {
      const data = {
        notes: null,
      }
      return data
    },
  },
}
</script>
